module.exports = __webpack_public_path__ + "img/service2.2574a012.jpg";